import angular from 'angular';
import uiRouter from 'angular-ui-router';
import changespercoderComponent from './changespercoder.component';

let changespercoderModule = angular.module('changespercoder', [
  uiRouter
])

.component('changespercoder', changespercoderComponent);

export default changespercoderModule;



// WEBPACK FOOTER //
// ./client/app/common/reports/changespercoder/changespercoder.js